/* =========================================================
   VELMORA — Trust counter count-up
   Runs only for blocks that opted in and whose value is numeric.
   Preserves the original formatting (thousands separators) and
   respects prefers-reduced-motion.
   ========================================================= */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var animationsOn = document.documentElement.getAttribute("data-animations") !== "false";

  function formatLike(raw, value) {
    // If the authored value used thousands separators, keep them.
    if (raw.indexOf(",") > -1) {
      return value.toLocaleString("en-US");
    }
    return String(value);
  }

  function run(el) {
    var target = parseInt(el.getAttribute("data-countup-target"), 10);
    var raw = el.getAttribute("data-countup-raw") || String(target);
    if (isNaN(target) || target <= 0) return;

    var duration = Math.min(1600, 700 + target.toString().length * 180);
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // easeOutExpo — fast start, gentle settle
      var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      el.textContent = formatLike(raw, Math.round(target * eased));
      if (progress < 1) {
        window.requestAnimationFrame(frame);
      } else {
        el.textContent = raw;
      }
    }

    el.textContent = formatLike(raw, 0);
    window.requestAnimationFrame(frame);
  }

  function init() {
    // Only the first (authoritative) copy of a marquee track carries
    // [data-countup]; duplicated copies are aria-hidden and static.
    var els = document.querySelectorAll("[data-countup]:not([data-countup-done])");
    if (!els.length) return;

    if (prefersReduced || !animationsOn || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.setAttribute("data-countup-done", "true");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          if (el.getAttribute("data-countup-done")) return;
          el.setAttribute("data-countup-done", "true");
          run(el);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
